import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import ChangeCourseActionTypes from './changeCourse.types';

import UtilsTypes from '../utilities/utils.types';
import { UPDATE_ACTIVE_COURSE } from '../userAuthentication/userAuth.actionTypes';
import MyCourseActionTypes from '../myCourse/myCourse.types';
import {
	clearLocalStorage,
	getParameterByName,
} from '../../utils/commonFunctions';
import Loader from '../../utils/Loader';
import { getChildToken } from '../parentDashboard/parentDashboard.selector';
import { getUserType } from '../userAuthentication/userAuth.selectors';
import UserTypes from '../../utils/userTypes';
function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function* setErrorPanel(errorPanel) {
	Loader.hide();
	yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: errorPanel });
}

function* changeCourse({ payload }) {
	let childToken = yield select(getChildToken);
	let userType = yield select(getUserType);
	try {
		Loader.show();
		const res = yield call(Api, {
			url: 'courses',
			method: 'POST',
			data: {
				course_id: payload.courseId,
			},
			headers: {
				'access-token':
					userType === UserTypes.Parent ? childToken : localStorage.getItem('token'),
			},
		});
		if (!res.status) {
			yield call(setErrorPanel, {
				panelMsg:
					'The course you selected is not purchased yet. Please select a course that is already available for you.',
				panelClass: 'alert alert-danger',
			});
			if (res === 'User has not purchased the course.') {
				yield put(push('/mydashboard'));
			} else if (res.includes('Your course has expired.')) {
				yield put(push('/mydashboard'));
				yield call(setErrorPanel, {
					panelMsg: res,
					panelClass: 'alert alert-danger',
				});
			} else {
				yield call(setError, res);
			}
		} else {
			if (res.code === 200) {
				if (userType === 'regular' || getParameterByName('previewMode') === '1') {
					Loader.hide();
					yield call(setErrorPanel, {});
					sessionStorage.clear();
					yield put({ type: MyCourseActionTypes.RESET_UNIT_ID });
					if (
						getParameterByName('previewMode') !== '1' &&
						payload.courseId !== localStorage.getItem('active_course_id')
					) {
						yield put({
							type: MyCourseActionTypes.SET_PREVIEW_MODE,
							payload: false,
						});
					}
					yield put({
						type: UPDATE_ACTIVE_COURSE,
						payload: payload.courseId,
					});

					if (!!payload.callback) {
						yield put({ type: payload.callback });
					} else if (window.location.search.includes('course_id')) {
						yield put({ type: MyCourseActionTypes.FETCH_COURSE_DETAILS.PENDING });
					} else {
						yield put(push('/mycourse'));
					}
				}
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('change course', err);
	}
}

function* fetchCourses() {
	Loader.show();
	try {
		const res = yield call(Api, {
			url: 'courses',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			Loader.hide();
			yield call(setError, res);
		} else {
			yield put({
				type: ChangeCourseActionTypes.FETCH_COURSES.SUCCESS,
				payload: res.data,
			});
		}
	} catch (err) {
		console.log('change course', err);
	}
}

function* changeActiveCourseStart() {
	yield takeLatest(
		ChangeCourseActionTypes.CHANGE_ACTIVE_COURSE.PENDING,
		changeCourse,
	);
}

function* fetchCoursesStart() {
	yield takeLatest(ChangeCourseActionTypes.FETCH_COURSES.PENDING, fetchCourses);
}

export function* allCourseSagas() {
	yield all([call(fetchCoursesStart), call(changeActiveCourseStart)]);
}
